import { createBrowserHistory } from 'history';
import 'moment/locale/pt-br';
import "react-image-gallery/styles/css/image-gallery.css";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import configStore from './redux/config.store';
import { start, stop } from './redux/loader/loader.actions';
import registerServiceWorker from './registerServiceWorker';

const history = createBrowserHistory()
const store = configStore(routerMiddleware(history))
store.dispatch(start())

setTimeout(() => {
  store.dispatch(stop())
}, 1000)

const ThemeConfigure = () => {
  const body = document.getElementsByTagName('body');
  const theme = localStorage.getItem('theme');
  if (theme === 'light-theme' && body[0].classList.contains('dark-theme')) {
    body[0].classList.remove('dark-theme');
  }

  if (theme === 'dark-theme') {
    body[0].classList.add('dark-theme');
  }
}

ThemeConfigure()

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <React.Fragment>
        <App />
        <ToastContainer />
      </React.Fragment>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js